<template>
    <div v-if="!this.selectedClient">
        <ClientRequirement
            v-if="user_uid && user_role !== null && user_role !== undefined"
            :selectedClient="selectedClient"
            :clientOptions="clientOptionsDisplay()"
            :colorScheme="colorScheme"
            @handle-selected-client="handleSelectedClient"
        />
    </div>
    <div v-else :class="layoutContainerClass" @click="onDocumentClick">
        <div class="layout-main">
            <AppTopBar
                v-if="user_uid && user_role !== null && user_role !== undefined"
                :items="menu"
                :menuMode="menuMode"
                :colorScheme="colorScheme"
                :menuActive="menuActive"
                :topbarMenuActive="topbarMenuActive"
                :topbarApicalMenuActive="topbarApicalMenuActive"
                :activeInlineProfile="activeInlineProfile"
                :selectedClient="selectedClient"
                :userUid="user_uid"
                :userRole="user_role"
                :clientOptions="clientOptionsDisplay()"
                :selectedDatabase="database"
                :databaseOptions="databaseOptionsDisplay()"
                @topbar-item-click="onTopbarItemClick"
                @topbar-apical-item-click="onTopbarApicalItemClick"
                @menubutton-click="onMenuButtonClick"
                @sidebar-mouse-over="onSidebarMouseOver"
                @sidebar-mouse-leave="onSidebarMouseLeave"
                @toggle-menu="onToggleMenu"
                @change-inlinemenu="onChangeActiveInlineMenu"
                @menu-click="onMenuClick"
                @menuitem-click="onMenuItemClick"
                @root-menuitem-click="onRootMenuItemClick"
                @handle-selected-client="handleSelectedClient"
                @handle-selected-database="handleSelectedDatabase"
            />

            <AppMenu
                id="app"
                :userRole="user_role"
                :model="menu"
                :menuMode="menuMode"
                :colorScheme="colorScheme"
                :menuActive="menuActive"
                :sidebarActive="sidebarActive"
                :sidebarStatic="sidebarStatic"
                :pinActive="pinActive"
                :activeInlineProfile="activeInlineProfile"
                @sidebar-mouse-over="onSidebarMouseOver"
                @sidebar-mouse-leave="onSidebarMouseLeave"
                @toggle-menu="onToggleMenu"
                @change-inlinemenu="onChangeActiveInlineMenu"
                @menu-click="onMenuClick"
                @menuitem-click="onMenuItemClick"
                @root-menuitem-click="onRootMenuItemClick"
            />

            <div class="layout-main-content" style="padding-top: 5px">
                <router-view
                    v-if="user_role !== null && user_role !== undefined"
                    :key="$route.fullPath"
                    :selectedClient="selectedClient"
                    :selectedDatabase="database"
                    :userRole="user_role"
                    :clientOptions="clientOptions"
                />
            </div>

            <AppFooter :colorScheme="colorScheme" />
        </div>

        <AppRightMenu
            :rightMenuActive="rightMenuActive"
            @rightmenu-click="onRightMenuClick"
            @rightmenu-active="onChangeRightMenuActive"
        />
    </div>
</template>

<script>
import AppTopBar from './AppTopbar.vue';
import AppMenu from './AppMenu.vue';
import AppRightMenu from './AppRightMenu.vue';
import AppFooter from './AppFooter.vue';
import EventBus from './event-bus';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { getUserRole, post_request } from '@/store/sharedFunctions';
import { DatabaseOptions } from '@/store/constants';
import ClientRequirement from './ClientRequirement.vue';

export default {
    emits: [
        'layout-mode-change',
        'menu-theme',
        'layoutModeChange',
        'sidebar-mouse-over',
        'sidebar-mouse-leave',
        'change-inlinemenu',
        'handle-selected-client',
    ],
    props: {
        topbarTheme: String,
        theme: String,
        componentTheme: String,
    },
    data() {
        return {
            colorScheme: this.$store.state.dbcalls.userDoc
                ? this.$store.state.dbcalls.userDoc.preference.theme
                : this.$appState.defaultColorScheme,
            search: false,
            searchClick: false,
            searchActive: false,
            menuMode: 'overlay',
            menuActive: false,
            activeInlineProfile: false,
            inlineMenuClick: false,
            overlayMenuActive: false,
            topbarMenuActive: false,
            topbarApicalMenuActive: false,
            topbarApicalItemClick: false,
            topbarItemClick: false,
            sidebarActive: false,
            sidebarStatic: false,
            pinActive: false,
            staticMenuDesktopInactive: false,
            staticMenuMobileActive: false,
            rightMenuClick: false,
            rightMenuActive: false,
            configActive: false,
            configClick: false,
            selectedClient: null,
            database: null,
            databaseOptions: null,
            user_auth: null,
            user_uid: null,
            user_role: null,
            clientOptions: null,
            menu: [
                {
                    label: 'Client Overview',
                    icon: 'pi pi-fw pi-id-card',
                    to: '/client-overview',
                },
                {
                    label: 'Acquisition',
                    icon: 'pi pi-fw pi-bolt',
                    to: '/list-generation',
                },
                {
                    label: 'Match List',
                    icon: 'pi pi-fw pi-list',
                    to: '/match-list',
                },
                {
                    label: 'My Saved Queries',
                    icon: 'pi pi-fw pi-user',
                    to: '/user-queries',
                },
                {
                    label: 'Candidate Search',
                    icon: 'pi pi-fw pi-search',
                    to: '/candidate-search',
                },
                {
                    label: 'Admin',
                    disabled: true,
                    roles: ['admin'],
                },
                {
                    label: 'Client Registration',
                    icon: 'pi pi-fw pi-user-plus',
                    to: '/client-intake',
                    roles: ['admin', 'analyst'],
                },
                {
                    label: 'List Enforcement',
                    icon: 'pi pi-fw pi-lock',
                    to: '/list-enforcement',
                    roles: ['admin'],
                },
            ],
        };
    },
    watch: {
        $route() {
            this.menuActive = false;
            this.$toast.removeAllGroups();
        },
    },
    methods: {
        onDocumentClick() {
            if (!this.searchClick && this.searchActive) {
                this.onSearchHide();
            }

            if (!this.topbarItemClick) {
                this.topbarMenuActive = false;
            }

            if (!this.topbarApicalItemClick) {
                this.topbarApicalMenuActive = false;
            }

            if (!this.menuClick) {
                if (this.isHorizontal() || this.isSlim()) {
                    this.menuActive = false;
                    EventBus.emit('reset-active-index');
                }

                if (this.overlayMenuActive || this.staticMenuMobileActive) {
                    this.overlayMenuActive = false;
                    this.staticMenuMobileActive = false;
                }

                this.hideOverlayMenu();
                this.unblockBodyScroll();
            }

            if (!this.rightMenuClick) {
                this.rightMenuActive = false;
            }

            if (this.configActive && !this.configClick) {
                this.configActive = false;
            }

            this.topbarItemClick = false;
            this.topbarApicalItemClick = false;
            this.menuClick = false;
            this.configClick = false;
            this.rightMenuClick = false;
            this.searchClick = false;
            this.inlineMenuClick = false;
        },
        onSearchHide() {
            this.searchActive = false;
            this.searchClick = false;
        },
        onSidebarMouseOver() {
            if (this.menuMode === 'sidebar' && !this.sidebarStatic) {
                this.sidebarActive = this.isDesktop();
                setTimeout(() => {
                    this.pinActive = this.isDesktop();
                }, 200);
            }
        },
        onSidebarMouseLeave() {
            if (this.menuMode === 'sidebar' && !this.sidebarStatic) {
                setTimeout(() => {
                    this.sidebarActive = false;
                    this.pinActive = false;
                }, 250);
            }
        },
        hideOverlayMenu() {
            this.overlayMenuActive = false;
            this.staticMenuMobileActive = false;
        },
        onMenuButtonClick(event) {
            this.menuClick = true;

            if (this.isOverlay()) {
                this.overlayMenuActive = !this.overlayMenuActive;
            }

            if (this.isDesktop()) {
                this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
            } else {
                this.staticMenuMobileActive = !this.staticMenuMobileActive;
            }

            event.preventDefault();
        },
        onTopbarItemClick(event) {
            this.topbarItemClick = true;
            this.topbarMenuActive = !this.topbarMenuActive;
            this.hideOverlayMenu();
            event.preventDefault();
        },
        onTopbarApicalItemClick(event) {
            this.topbarApicalItemClick = true;
            this.topbarApicalMenuActive = !this.topbarApicalMenuActive;
            event.preventDefault();
        },
        onRightMenuButtonClick() {
            this.rightMenuClick = true;
            this.rightMenuActive = true;
        },
        onRightMenuClick() {
            this.rightMenuClick = true;
        },
        onMenuClick() {
            this.menuClick = true;
        },
        onRootMenuItemClick() {
            this.menuActive = !this.menuActive;
        },
        onMenuItemClick(event) {
            if (!event.item.items) {
                this.hideOverlayMenu();
                EventBus.emit('reset-active-index');
            }

            if (!event.item.items && (this.isHorizontal() || this.isSlim())) {
                this.menuActive = false;
            }
        },
        onChangeMenuMode(menuMode) {
            this.menuMode = menuMode;
            this.overlayMenuActive = false;
        },
        onConfigClick() {
            this.configClick = true;
        },
        onConfigButtonClick(event) {
            this.configActive = !this.configActive;
            this.configClick = true;
            event.preventDefault();
        },
        onChangeRightMenuActive(active) {
            this.rightMenuActive = active;
        },
        onToggleMenu(event) {
            this.menuClick = true;

            if (this.overlayMenuActive) {
                this.overlayMenuActive = false;
            }

            if (this.sidebarActive) {
                this.sidebarStatic = !this.sidebarStatic;
            }

            event.preventDefault();
        },
        onChangeActiveInlineMenu() {
            this.activeInlineProfile = !this.activeInlineProfile;
        },
        blockBodyScroll() {
            if (document.body.classList) {
                document.body.classList.add('blocked-scroll');
            } else {
                document.body.className += ' blocked-scroll';
            }
        },
        unblockBodyScroll() {
            if (document.body.classList) {
                document.body.classList.remove('blocked-scroll');
            } else {
                document.body.className = document.body.className.replace(
                    new RegExp('(^|\\b)' + 'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'),
                    ' '
                );
            }
        },
        isHorizontal() {
            return this.menuMode === 'horizontal';
        },
        isSlim() {
            return this.menuMode === 'slim';
        },
        isOverlay() {
            return this.menuMode === 'overlay';
        },
        isStatic() {
            return this.menuMode === 'static';
        },
        isSidebar() {
            return this.menuMode === 'sidebar';
        },
        isDesktop() {
            return window.innerWidth > 991;
        },
        isMobile() {
            return window.innerWidth <= 991;
        },
        replaceLink(linkElement, href, callback) {
            const id = linkElement.getAttribute('id');
            const cloneLinkElement = linkElement.cloneNode(true);

            cloneLinkElement.setAttribute('href', href);
            cloneLinkElement.setAttribute('id', id + '-clone');

            linkElement.parentNode.insertBefore(cloneLinkElement, linkElement.nextSibling);

            cloneLinkElement.addEventListener('load', () => {
                linkElement.remove();
                cloneLinkElement.setAttribute('id', id);

                if (callback) {
                    callback();
                }
            });
        },
        updateTheme(theme) {
            const themeLink = document.getElementById('theme-css');
            const themehref = 'theme/green/theme-' + theme + '.css';
            const layoutLink = document.getElementById('layout-css');
            const layouthref = 'layout/css/green/layout-' + theme + '.css';
            this.replaceLink(themeLink, themehref);
            this.replaceLink(layoutLink, layouthref);
        },
        handleSelectedClient(event) {
            this.selectedClient = this.clientOptions.find((client) => client['uuid'] === event['uuid']);
            this.$store.dispatch('updateClient', this.selectedClient);
        },
        handleSelectedDatabase(event) {
            let reduce = ({ name, value }) => ({ name, value });
            this.database = reduce({ ...event.value });
        },
        async fetchClientOptions(userID) {
            if (userID !== '' && userID !== undefined && userID !== null) {
                const data = { uid: userID };
                const fetchClientList = await post_request('fetch-client-list', data);
                const fetchedJSON = await fetchClientList.json();
                this.clientOptions = fetchedJSON.clientList;
            } else {
                console.log('Invalid uid ', userID);
            }
        },
        clientOptionsDisplay() {
            let displayOptions =
                this.selectedClient && !this.clientOptions ? [this.selectedClient] : this.clientOptions;

            if (displayOptions) {
                return displayOptions.map((client) => ({
                    name: client['name'],
                    uuid: client['uuid'],
                }));
            }
        },
        databaseOptionsDisplay() {
            const availableOptions = DatabaseOptions.filter((db) => db.roles.includes(this.user_role));
            return availableOptions.map((db) => ({
                name: db.name,
                value: db.value,
            }));
        },
        defaultDatabase() {
            return (({ name, value }) => ({ name, value }))({ ...DatabaseOptions.find((db) => db.value === 0) });
        },
    },
    computed: {
        layoutContainerClass() {
            return [
                'layout-wrapper',
                {
                    'layout-static': this.menuMode === 'static',
                    'layout-overlay': this.menuMode === 'overlay',
                    'layout-overlay-active': this.overlayMenuActive,
                    'layout-slim': this.menuMode === 'slim',
                    'layout-horizontal': this.menuMode === 'horizontal',
                    'layout-active': this.menuActive,
                    'layout-mobile-active': this.staticMenuMobileActive,
                    'layout-sidebar': this.menuMode === 'sidebar',
                    'layout-sidebar-static': this.menuMode === 'sidebar' && this.sidebarStatic,
                    'layout-static-inactive': this.staticMenuDesktopInactive && this.menuMode === 'static',
                    'p-ripple-disabled': this.$primevue.config.ripple === false,
                },
            ];
        },
    },
    components: {
        AppTopBar,
        AppMenu,
        AppRightMenu,
        AppFooter,
        ClientRequirement,
    },
    created() {
        this.$store.dispatch('watchUserDoc');
        this.selectedClient = this.$store.state.dbcalls.selectedClient;
    },
    async mounted() {
        this.user_auth = getAuth();
        onAuthStateChanged(this.user_auth, async () => {
            this.user_uid = this.user_auth.lastNotifiedUid;
            getUserRole(this.user_auth).then((role) => {
                this.user_role = role;
            });

            if (!this.clientOptions) {
                await this.fetchClientOptions(this.user_uid).then(() => {
                    if (this.selectedClient !== null) {
                        this.handleSelectedClient(this.selectedClient);
                    }
                });
            }
            if (!this.databaseOptions) {
                this.databaseOptions = this.databaseOptionsDisplay();
            }
            if (!this.database) {
                this.database = this.defaultDatabase();
            }
        });
        this.updateTheme(
            this.$store.state.auth.user && this.$store.state.dbcalls.userDoc
                ? this.$store.state.dbcalls.userDoc.preference.theme
                : this.$appState.defaultColorScheme
        );
    },
};
</script>
